import { apiClient } from './api';
import {
  AnalyzeImageRequest,
  AnalyzeImageResponse,
  GenerateCinematicSummaryRequest,
  CinematicSummaryResponse
} from '../models/imageAnalysis';

export class ImageAnalysisService {
  static async analyzeImageBytes(request: AnalyzeImageRequest): Promise<AnalyzeImageResponse> {
    const response = await apiClient.post('/api/imageanalysis/analyze-bytes', request);
    return response.data;
  }

  static async analyzeImageUrl(request: AnalyzeImageRequest): Promise<AnalyzeImageResponse> {
    const response = await apiClient.post('/api/imageanalysis/analyze-url', request);
    return response.data;
  }

  static async generateCinematicSummary(request: GenerateCinematicSummaryRequest): Promise<CinematicSummaryResponse> {
    const response = await apiClient.post('/api/imageanalysis/cinematic-summary', request);
    return response.data;
  }

  // Helper method to convert file to base64
  static async fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64 = reader.result as string;
        // Remove data URL prefix (e.g., "data:image/jpeg;base64,")
        const base64Data = base64.split(',')[1];
        resolve(base64Data);
      };
      reader.onerror = error => reject(error);
    });
  }
}

export default ImageAnalysisService;